import { useCallback, useMemo } from 'react'
import { sortByTitle } from 'app/common/lib/sort'

import { useMachineForm, useMachineValidate } from 'app/dataProviders/VendingDataProvider'
import useBuildingsData from 'app/components/common/BuildingsData/useBuildingsData'
import type { ItemType } from 'app/common/ui-next/plain-selector/types'

type Result = {
  buildings: Array<ItemType>
  loadingBuildings: boolean
  buildingSelection: Array<string>
  changeCurrentBuilding: (values: Array<string>) => void
}

export function useActualBuildings(): Result {
  const [{ orgId, buildingId }, { update }] = useMachineForm()
  const [, , resetErrors] = useMachineValidate()

  const orgSelected = Boolean(orgId)
  const [buildings, loadingBuildingsRaw] = useBuildingsData(orgId, orgSelected)

  const buildingsItems = useMemo<Array<ItemType>>(
    () => sortByTitle(Object.values(buildings).map(({ id, title }) => ({ id: String(id), title }))),
    [buildings],
  )

  const loadingBuildings = orgSelected ? loadingBuildingsRaw : false

  const buildingSelection = useMemo(
    () => (buildingId ? [String(buildingId)] : []),
    [buildingId],
  )

  const changeCurrentBuilding = useCallback(
    ([buildingId_]: Array<string>) => {
      resetErrors()
      const nextBuildingId = parseInt(buildingId_, 10) || 0
      update(state => ({
        ...state,
        buildingId: nextBuildingId,
        salePointId: 0,
      }))
    },
    [update, resetErrors],
  )

  return {
    buildings: buildingsItems,
    loadingBuildings,
    buildingSelection,
    changeCurrentBuilding,
  }
}
